import { Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { SEGMENT_LABELS } from './nav';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function labelFor(segment: string): string {
  if (SEGMENT_LABELS[segment]) return SEGMENT_LABELS[segment];
  if (UUID.test(segment)) return 'Detalhe';
  return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
}

export function Breadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  return (
    <nav aria-label="Trilha de navegação" className="min-w-0">
      <ol className="flex flex-wrap items-center gap-1 text-xs text-muted">
        <li>
          <Link to="/" className="transition hover:text-fg">
            Início
          </Link>
        </li>
        {segments.map((segment, index) => {
          const to = `/${segments.slice(0, index + 1).join('/')}`;
          const isLast = index === segments.length - 1;
          return (
            <Fragment key={to}>
              <li aria-hidden>
                <ChevronRight className="h-3 w-3" />
              </li>
              <li>
                {isLast ? (
                  <span className="font-medium text-fg" aria-current="page">
                    {labelFor(segment)}
                  </span>
                ) : (
                  <Link to={to} className="transition hover:text-fg">
                    {labelFor(segment)}
                  </Link>
                )}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
